@if (showConfirmation) {
    <cerrix-button
        size="small"
        color="error"
        [dataUiid]="dataUiid + '-confirm'"
        (click)="onButtonClick($event)"
        >{{ btnLabel
        }}<mat-icon fontSet="material-symbols-outlined">{{ icon }}</mat-icon></cerrix-button
    >
} @else {
    <cerrix-icon-button
        color="accent-link"
        size="small"
        [dataUiid]="dataUiid"
        (click)="onIconClick($event)"
    >
        <mat-icon fontSet="material-symbols-outlined">{{ icon }}</mat-icon>
    </cerrix-icon-button>
}
